import { ISerializedPaginatedQuery } from "@smartrr/shared/utils/paginatedQuery";

import { typedCustomerFrontendApi } from "@customer-app/shared/typedCustomerFrontendApi";
import { customerAsyncDispatch } from "@customer-app/state/customerAsyncDispatch";
import { CustomerThunkAction } from "@customer-app/state/typedCustomerRedux";

export const loadOrders =
  (
    query?: ISerializedPaginatedQuery
  ): CustomerThunkAction<
    // TS throwing build error if user action types are not specified
    "LOADING_ORDERS" | "ERROR_LOADING_ORDERS" | "LOADED_ORDERS"
  > =>
  dispatch =>
    customerAsyncDispatch(
      typedCustomerFrontendApi.getReq("/orders", { query }),
      () =>
        dispatch({
          type: "LOADING_ORDERS",
          payload: undefined,
        }),
      () =>
        dispatch({
          type: "ERROR_LOADING_ORDERS",
          payload: {
            errorMessage: "error loading orders",
          },
        }),
      orders =>
        dispatch({
          type: "LOADED_ORDERS",
          payload: { orders },
        })
    );
